import { useRestore } from '@/configs/global.config';
import { headerAcceptLanguage } from '@/helpers/functions';
import * as types from '../mutation-types'

export default {
	namespaced: true,
	state: {
		services: []
	},

	actions: {
		fetchAll({ commit }, { useOrder }) {
			return axios.get('/services', {
				params: { useOrder }
			}).then(({ data }) => {
				const storeData = data.filter(c => !useRestore.services ? !c.deletedAt : true);
				commit(types.STORE_SERVICES, storeData);
				return storeData;
			})
		},

		fetchBySlug({ commit }, { slug, acceptLanguage }) {
			const configs = headerAcceptLanguage(acceptLanguage);
			return axios.get(`/services/${slug}`, configs).then(({ data }) => data);
		},

		create({ commit }, { title, summary, filterIds, code, content, descriptionSeo, keywordsSeo, date, isFeatured, inHomePage, benefits, image, imagePath, imageName, acceptLanguage }) {
			const configs = headerAcceptLanguage(acceptLanguage);

			const formData = new FormData();

			const requestData = { title, summary, code, content, descriptionSeo, keywordsSeo, date, image, imageName };

			Object.keys(requestData).forEach(key => {
				if (requestData[key]) {
					formData.append(key, requestData[key]);
				}
			});

			filterIds.forEach(id => formData.append('filterIds[]', id));
			
			if (imagePath) formData.append('imagePath', imagePath.slice(imagePath.indexOf('/', 1)));

			formData.append('isFeatured', isFeatured ? 1 : 0);
			formData.append('inHomePage', inHomePage ? 1 : 0);

			if (benefits) {
				benefits.forEach((item, i) => {
					if (item.image) formData.append(`benefits[${i}][image]`, item.image);
					if (item.imagePath) formData.append(`benefits[${i}][imagePath]`, item.imagePath);
					if (item.imageName) formData.append(`benefits[${i}][imageName]`, item.imageName);
					formData.append(`benefits[${i}][title]`, item.title);
					formData.append(`benefits[${i}][description]`, item.description);
				});
			}

			return axios.post('/services', formData, configs).then(({ data }) => data);
		},
		
		update({ commit }, { id, title, summary, filterIds, code, content, descriptionSeo, keywordsSeo, date, isFeatured, inHomePage, benefits, image, imagePath, imageName, acceptLanguage }) {
			const configs = headerAcceptLanguage(acceptLanguage);

			const formData = new FormData();
			
			const requestData = { title, summary, code, content, descriptionSeo, keywordsSeo, date, image, imageName };

			Object.keys(requestData).forEach(key => {
				if (requestData[key]) {
					formData.append(key, requestData[key]);
				}
			});

			filterIds.forEach(id => formData.append('filterIds[]', id));
			
			if (imagePath) formData.append('imagePath', imagePath.slice(imagePath.indexOf('/', 1)));
			
			formData.append('isFeatured', isFeatured ? 1 : 0);
			formData.append('inHomePage', inHomePage ? 1 : 0);

			if (benefits) {
				benefits.forEach((item, i) => {
					if (item.image) formData.append(`benefits[${i}][image]`, item.image);
					if (item.imagePath) formData.append(`benefits[${i}][imagePath]`, item.imagePath);
					if (item.imageName) formData.append(`benefits[${i}][imageName]`, item.imageName);
					formData.append(`benefits[${i}][title]`, item.title);
					formData.append(`benefits[${i}][description]`, item.description);
				});
			}

			formData.append('_method', 'PUT');

			return axios.post(`/services/${id}`, formData, configs).then(({ data }) => data);
		},

		uploadImages({ commit }, { id, images, imagesPaths, imagesNames }) {
			const formData = new FormData();
			images.forEach(image => {
				formData.append('images[]', image)
			});
			imagesPaths.forEach(path => {
				formData.append('imagesPaths[]', path.slice(path.indexOf('/', 1)));
			});
			imagesNames.forEach(name => {
				formData.append('imagesNames[]', name);
			});

			return axios.post(`/services/${id}/add-images`, formData)
		},

		deleteImage({ commit }, { id, imageId }) {
			return axios.post(`/services/${id}/images/${imageId}`, { _method: 'DELETE' })
		},

		changeOrder({ commit }, { id, order }) {
			return axios.post(`/services/${id}/change-order`, { num: order, _method: 'PUT' });
		},

		delete({ commit }, { id }) {
			return axios.post(`/services/${id}`, { _method: 'DELETE' })
		},

		restore({ commit }, { id }) {
			return axios.post(`/services/${id}`, { _method: 'PATCH' })
		},
	},

	mutations: {
		[types.STORE_SERVICES](state, services) {
			state.services = services;
		}
	},

	getters: {
		getServiceById: state => id => state.services.find(c => c.id === id),
		getServiceBySlug: state => slug => state.services.find(c => c.slug === slug),
	}
}